import React from "react";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import advancedPlanImage from "@app/assets/billing/advanced-plan-image.svg";
import InfoBlockWithImage from "@app/component/typography/InfoBlockWithImage";

import styles from "./AdvancedPlanInfoCard.module.scss";

interface Props {
  className?: string;
  compactUi?: boolean;
}

const AdvancedPlanInfoCard: React.FC<Props> = ({ className, compactUi }) => {
  const intl = useIntl();
  return (
    <div className={className}>
      <InfoBlockWithImage
        action={
          <Button href="https://mapmycustomers.com/contact-sales/" target="_blank">
            {intl.formatMessage({
              id: "billing.information.advancedPlan.cta",
              defaultMessage: "Get in touch about our Advanced plan",
              description: "Call to action button title in Advanced Plan card on Billing page",
            })}
          </Button>
        }
        className={styles.content}
        image={compactUi ? undefined : advancedPlanImage}
        subTitle={intl.formatMessage({
          id: "billing.information.advancedPlan.text",
          defaultMessage:
            "Get two-way integrations, API Access, professional services, hands-on training and a dedicated account manager.",
          description: "Description of the Advanced Plan card on Billing page",
        })}
        title={
          <span className={styles.title}>
            {intl.formatMessage({
              id: "billing.information.advancedPlan.title",
              defaultMessage: "Fully tailor Map My Customers for your organization",
              description: "Title of the Advanced Plan card on Billing page",
            })}
          </span>
        }
      />
    </div>
  );
};

export default AdvancedPlanInfoCard;
